import { render, staticRenderFns } from "./CommodityMp.vue?vue&type=template&id=628a502e&scoped=true&"
import script from "./CommodityMp.vue?vue&type=script&lang=js&"
export * from "./CommodityMp.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMp.vue?vue&type=style&index=0&id=628a502e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a502e",
  null
  
)

export default component.exports